import React from "react";
import { useParams } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import Action from "../../../Action/Action";
import { Panel } from "@poseidon/ui/components/Panel";
import { FileManagement } from "../../../Files";
import { useApplication } from "../../hooks/useApplication";
import { CircularProgress } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import config from "@poseidon/utils/config";
import { isApplicationEditable } from "../../isApplicationEditable";
import { capitalizeFirstLetter } from "@poseidon/utils/string";

export default function FileManagementPage({ fileCategory }) {
  const params = useParams();
  const { applicationId, fileGroup } = params;
  const { application, loading, error } = useApplication(applicationId);
  const { setError } = useErrorMessage();
  const { getFileResolver } = config;
  const readonly = !isApplicationEditable(application);

  useCrumb("/applications/:applicationId/:fileGroup/files", {
    to: `/applications/:applicationId/:fileGroup/files`,
    text: getFileResolver(fileGroup).fileGroupLabel,
  });

  if (error) {
    setError(error);
  }

  if (loading || !application) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <Typography variant="h5">Files &amp; Actions</Typography>
      <Panel
        title={`${capitalizeFirstLetter(fileGroup)} File Management`}
        expandable
      >
        <FileManagement
          fileCategory={fileCategory}
          resolveMetadata={config.getFileResolver(fileGroup)}
          applicationId={applicationId}
          readonly={readonly}
        />
      </Panel>
      {!Object.keys(config.fileDisplay.boat).includes(fileGroup) && (
        <Panel title={`${capitalizeFirstLetter(fileGroup)} Action status`}>
          <Action
            entity={config.SaltCollection.Application}
            entityId={applicationId}
            entityKey={fileGroup}
            application={application}
            readonly={readonly}
          />
        </Panel>
      )}
    </Stack>
  );
}
